import React, { useState } from 'react';

import MentorLessonList from '@/components/mentor/lesson/MentorLessonList';
import MentorLessonSearch from '@/components/mentor/lesson/MentorLessonSearch';
import { useTranslation } from '@/config/i18n';

const MentorLessonManagementPage: React.FC = () => {
  const [t] = useTranslation('');
  const [searchTrigger, setSearchTrigger] = useState(0);

  return (
    <>
      <div className="header-top flex items-center justify-between">
        <h2 className="title">{t('menu.mentor_lesson_management')}</h2>
      </div>
      <MentorLessonSearch
        onSearch={() => setSearchTrigger((prev) => prev + 1)}
      />
      <MentorLessonList searchTrigger={searchTrigger} />
    </>
  );
};

export default MentorLessonManagementPage;
